import { Grid } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import React, { useContext } from 'react';
import { SecondaryButton } from '../../../Core/FormInput';
import { postTCardsUpdateStatus } from '../../../Core/Service/T-card-services';
import AppContext from '../../../App/AppContext';

const UpdateTCardStatusModal = (props) => {
    console.log(props, 'props');
    const { showToast } = useContext(AppContext);

    const submitHandler = async () => {
        let res = await postTCardsUpdateStatus(props.newStatus, props.tCardID);
        if (res.data.success) {
            showToast(res.data.message);
            props.onSubmit(true);
        }
    };

    return (
        <div>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Alert severity="warning">{props.msg}</Alert>
                </Grid>
                <Grid item xs={6} clasName="submit_btn">
                    <SecondaryButton fullWidth onClick={submitHandler}>
                        yes
                    </SecondaryButton>
                </Grid>
                <Grid item xs={6} clasName="submit_btn">
                    <SecondaryButton fullWidth onClick={() => props.onClose(false)}>
                        no
                    </SecondaryButton>
                </Grid>
                <Grid xs={12}></Grid>
            </Grid>
        </div>
    );
};

export default UpdateTCardStatusModal;
